import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    total: -1,
    page: -1,
    page_size: -1,
    next: null,
    previous: null,
    results: [],
    columns: []
};

export const RegistrationSlice = createSlice({

  name: 'registrations',
  initialState,
  reducers: {

      load : (state, action) => {
          console.log('RegistrationSlice:load')
          console.log(action.payload)
          const payload = action.payload
          return {
               ...state,
               total: payload.total,
               page: payload.page,
               page_size: payload.page_size,
               results: [...payload.results],
               columns: [...payload.columns]
          }
      },
  }
});


export const { 
  load
} = RegistrationSlice.actions;

export default RegistrationSlice.reducer;
